import { styles as commonStyles } from '../../base/styles/common.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { FontSizes, FontWeights } from '../../../../../../webcomponents/src/types/common/types';

export const templateAzureADSensor = document.createElement('template');

templateAzureADSensor.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styleHelpersStyles}</style>
  <div class="form-wrapper" id="integration-types" class="sensor-wrapper">
    <gz-form-field  class="sensor-select-wrapper mb-2">
       <gz-checkbox gz-form-input class="sensor-select" style="display: none" checked></gz-checkbox>
    </gz-form-field>
    <div class="sensor-data">
      <gz-title fontWeight='${FontWeights.MEDIUM}' fontSize='${FontSizes.HEADING_6}' id="entra-id-app-credentials-id-title"></gz-title>
      <gz-title fontWeight='${FontWeights.LIGHT}' fontSize='${FontSizes.HEADING_6}' id="entra-id-subtitle"></gz-title>
      <br/>
      <div class="sensor-data-list">
        <gz-form-field label="" id="azure_ad_tenant_id" required stacked>
          <gz-input gz-form-input="" type="text" ></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
        <gz-form-field label="" id="azure_ad_application_id" required stacked>
          <gz-input gz-form-input="" type="text" ></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
        <gz-form-field label="" id="azure_ad_client_secret" required stacked>
          <gz-input gz-form-input="" type="password" ></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
      </div>
      <br/>
      <br/>
      <br/>
      <gz-title fontWeight='${FontWeights.MEDIUM}' fontSize='${FontSizes.HEADING_6}'  id="azure-event-hub-credentials-title"></gz-title>
      <br/>
      <div class="sensor-data-list">
        <gz-form-field label="" id="azure_ad_connection_string" required stacked>
          <gz-input gz-form-input="" type="password"></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
        <gz-form-field label="" id="azure_ad_hub_name" required stacked>
          <gz-input gz-form-input="" type="text" ></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
        <gz-form-field label="" id="azure_ad_consumer_group" stacked>
          <gz-input gz-form-input="" type="text" ></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
      </div>
      <gz-checkbox gz-form-input id='event-hub-checkbox' class='role-right-checkbox'></gz-checkbox>
      <gz-info-box severity='warning' class='mb-2 hidden' id='event-hub-info-box'></gz-info-box>
    </div>
  </div>
`;
